import React, { Component } from 'react';
import CarouselWrapper from './carousel';

class CarouselDataWrapper extends Component {
  static initialiseCarouselSlides(cardsPerSlide, contentToMap) {
    const items = [];
    for (let x = 0; x < contentToMap.length; x += cardsPerSlide) {
      items.push(contentToMap.slice(x, x + cardsPerSlide));
    }
    return items;
  }
  render() {
    const { cardsPerSlide, contentToMap } = this.props;
    const items = CarouselDataWrapper.initialiseCarouselSlides(cardsPerSlide, contentToMap);
    return (
      <CarouselWrapper items={items} {...this.props} />
    );
  }
}

export default CarouselDataWrapper;
